import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import _ from 'lodash'

import { Button } from 'reactstrap'
import { authSelector, teamSelector, divisionSelector } from './../../../selectors'
import { teamAction, divisionAction } from './../../../actions/'
import CustomModalMessage from '../../../components/modal-message'
import TeamForm from '../../../components/team'
import moment from '../../../lib/moment.js'

class CreateTeam extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      team_code: '',
      team: '',
      division_id: '',
      edit: false,
      id: '',
      activeTab: '1',
      start_date: '',
      is_active: false,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.deactivateTeam = this.deactivateTeam.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
  }
  componentDidMount() {
    this.props.listDivision(localStorage.getItem('access_token'))
    if (_.get(this.props, 'edit.edit')) {
      this.props.getTeam(_.get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (_.get(nextProps, 'teamGet')) {
      this.setState({
        team_code: _.get(nextProps, 'teamGet.team_code'),
        team: _.get(nextProps, 'teamGet.name'),
        division_id: _.get(nextProps, 'teamGet.division_id'),
        start_date: _.get(nextProps, 'teamGet.start_date') ? _.get(nextProps, 'teamGet.start_date') : '',
        is_active: _.get(nextProps, 'teamGet.is_active'),
      })
      this.props.resetGetTeam()
    }
    if (_.get(nextProps, 'edit')) {
      if (_.get(nextProps, 'edit.edit')) {
        this.setState({ id: _.get(nextProps, 'edit.id'), edit: false })
        this.props.handleClickEdit(false, '')
        this.props.getTeam(_.get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetTeam()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  handleDelete() {
    this.deactivateTeam()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  deactivateTeam() {
    this.props.deactivateTeam(_.get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  submitForm() {
    if (_.get(this.state, 'edit')) {
      this.props.editTeam(
        _.get(this.state, 'id'),
        {
          team_code: this.state.team_code,
          name: this.state.team,
          division_id: this.state.division_id,
          start_date: this.state.start_date === '' ? '' : moment(this.state.start_date),
          is_active: this.state.is_active,
        },
        localStorage.getItem('access_token'))
    }
  }
  render() {
    const button = (
      <div>
        <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton>
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    return (
    /* eslint no-underscore-dangle: 0 */
      <div>
        { _.get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ _.get(this.props, 'confirmType') === 'confirmDelete' }
            type={ _.get(this.props, 'confirmStatus') }
            message={ _.get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        { _.get(this.props, 'confirmType') === 'confirmDiscard' &&
        <CustomModalMessage
          hide={ this.props.cancelDiscard }
          show={ _.get(this.props, 'confirmType') === 'confirmDiscard' }
          type={ _.get(this.props, 'confirmStatus') }
          message={ _.get(this.props, 'confirmMessage') }
          button={ buttonDiscard }
        />
        }
        <TeamForm
          edit={ this.state.edit }
          list={ _.get(this.props, 'listDivisionData') }
          confrim={ _.get(this.props, 'confirm') }
          team_code={ this.state.team_code }
          team={ this.state.team }
          division_id={ this.state.division_id }
          start_date={ this.state.start_date }
          is_active={ this.state.is_active }
          button={ button }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handleInput={ this.handleInput }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
        />
      </div>
    )
  }
}

CreateTeam.propTypes = {
  editTeam: PropTypes.func.isRequired,
  getTeam: PropTypes.func.isRequired,
  listDivision: PropTypes.func.isRequired,
  resetGetTeam: PropTypes.func.isRequired,
  deactivateTeam: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  handleSpan: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  teamCreate: teamSelector.getCreateTeamData,
  teamEdit: teamSelector.getEditTeamData,
  teamGet: teamSelector.getGetTeamData,
  listDivisionData: divisionSelector.getListDivision,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createTeam: teamAction.createTeam,
  resetCreateTeam: teamAction.resetCreateTeam,
  editTeam: teamAction.editTeam,
  resetEditTeam: teamAction.resetEditTeam,
  getTeam: teamAction.getTeamByID,
  resetGetTeam: teamAction.resetGetTeam,
  listDivision: divisionAction.getDivision,
  listTeam: teamAction.getTeam,
  deactivateTeam: teamAction.deactivateTeam,
  resetDeactivateTeam: teamAction.resetDeactivateTeam,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CreateTeam)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/team/edit/index.js